// extracted by mini-css-extract-plugin
module.exports = {"root":"Hero-module--root--1pEEV"};